export const API_URL = "https://cfcp.emailarray.com/admin/json.php";
export default API_URL;
